import { colorsPalettes } from "@similarweb/styles";
import { IconButton, Tooltip } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";

import { SET_DEFAULT_HP_ICON_TOOLTIP_TEXT } from "../../text";

import * as SC from "./styles";
import { activationItemTestKeys } from "./testKeys";

type HoverIconsSchema = {
    isSelected: boolean;
    isHovered: boolean;
    isDefaultPageItem: boolean;
    onClick: (e: MouseEvent) => void;
};

const HoverIcons = ({ isSelected, isHovered, isDefaultPageItem, onClick }: HoverIconsSchema) => (
    <>
        {isSelected && !isHovered ? (
            <SC.CheckMarkWrapper data-automation={activationItemTestKeys.selectedItemIcon}>
                <SC.CheckMark
                    iconName="checked"
                    size="xs"
                    iconColor={colorsPalettes.blue[400]}
                />
            </SC.CheckMarkWrapper>
        ) : null}

        {isHovered || (isDefaultPageItem && !isSelected) ? (
            <Tooltip
                enabled={!isDefaultPageItem}
                content={translate(SET_DEFAULT_HP_ICON_TOOLTIP_TEXT)}
            >
                <span data-automation={activationItemTestKeys.defaultItemIcon}>
                    {isDefaultPageItem ? (
                        <SC.StartIconWrapper>
                            <SC.StyledStarIcon
                                iconName="star"
                                size="xs"
                                iconColor={colorsPalettes.blue[400]}
                            />
                        </SC.StartIconWrapper>
                    ) : (
                        <IconButton
                            onClick={onClick}
                            iconSize="xs"
                            isActivated={!isDefaultPageItem}
                            iconColor={colorsPalettes.blue[400]}
                            iconName="star-outline"
                            type="flat"
                        />
                    )}
                </span>
            </Tooltip>
        ) : null}
    </>
);

export default HoverIcons;
